module.exports = __webpack_public_path__ + "img/404.e2e5a2fb.svg";